<template>
  <div class="order-title-component">
    <div class="order-header clearfix">
      <div class="fl">{{payOrderView.orderType === 2 ? '订金': payOrderView.title}}</div>
      <div class="fr">
        <span>合计金额</span>
        <span class="price">{{priceUnit}}{{payOrderView.price}}</span>
      </div>
    </div>
    <div class="order-header text-right order-header-coupon">
      <template v-for="(coupon, index) in coupons">
        <div :key="index">
          <span>{{coupon.couponName}}</span>
          <span>-{{priceUnit}}{{coupon.couponPrice}}</span>
        </div>
      </template>
    </div>
    <div class="order-header header-right clearfix">
      <div class="fr right-module clearfix">
        <span class="fl">应付金额</span>
        <span class="price red-price fr">
          <template v-if="realPrice">{{priceUnit}}{{realPrice}}</template>
        </span>
      </div>
    </div>
    <div
      v-if="showOrderDetail"
      class="order-detail"
    >
      <template v-if="payOrderView.orderType === 2">
        <div class="detail-item clearfix">
          <label>订单项目：</label>
          <ul>
            <li class="clearfix">
              <span class="fl">预付订金</span>
              <span class="fr">
                <span class="hour-num">1</span>
              </span>
            </li>
          </ul>
        </div>
      </template>
      <template v-else>
        <div class="detail-item clearfix">
          <label>订单项目：</label>
          <ul>
            <template v-for="(o, i) in payOrderView.packOrderDetailPcView">
              <li
                class="clearfix"
                v-if="showCourseName(o)"
                :key="i"
              >
                <span class="fl">{{o.courseName}}
                  <span
                    v-if="o.isFree"
                    class="free"
                  >赠</span>
                </span>
                <span class="fr">
                  <span class="hour-num">{{o.classHour}}</span>
                </span>
              </li>
            </template>
          </ul>
        </div>
      </template>
      <div class="detail-item clearfix">
        <label>订单日期：</label>
        <span>{{payOrderView.createDateTime}}</span>
      </div>
      <div class="detail-item clearfix">
        <label>订单编号：</label>
        <span>{{payOrderView.serialNumber}}</span>
      </div>
      <div v-if="payOrderView.haveMajor && payOrderView.totalPrice">
        <div>( 注：为保证和提高教学质量，VIPKID可根据学员实际学习情况对VIPKID主修课程所含学习周期测评数量进行相应调整 )</div>
      </div>

    </div>
    <div class="show-order-detail-btn">
      <span
        @click="showOrderDetail = !showOrderDetail"
        :class="{'span-up' : showOrderDetail}"
      >
        订单详情
      </span>
    </div>
  </div>
</template>

<script>
import { CURRENCY_LABEL } from '@/util/const'

export default {
  props: {
    payOrderView: {
      type: Object,
      default: () => {
        return {}
      }
    },
    realPrice: {
      type: [String, Number],
      default: ''
    },
    coupons: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      showOrderDetail: false
    }
  },
  computed: {
    priceUnit() {
      return CURRENCY_LABEL[this.payOrderView.currency]
    }
  },
  methods: {
    showCourseName(o) {
      return !(o.courseName == 'IT Test-电脑检测' || o.courseName == '全程中教指导')
    }
  }
}
</script>

<style lang="less" scoped>
.order-title-component {
  width: 100%;
  margin: 0 auto 15px;
  border: 1px solid #e0e0e0;
  background-color: #fff;
  padding: 15px 25px;
  border-radius: 3px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.15);
  .price {
    min-width: 105px;
    font-weight: 400;
    color: #333;
    text-align: right;
    &.red-price {
      color: #f85415;
      font-size: 20px;
      font-weight: bolder;
      height: 28px;
      line-height: 28px;
    }
  }
  .hour-num {
    display: inline-block;
    padding-left: 11px;
    background: url("../../../../assets/images/order/bg.png") no-repeat -123px -43px;
  }
  .order-header {
    margin-bottom: 7px;
    font-size: 14px;
    zoom: 1;
    color: #666;
    span {
      display: inline-block;
      &:first-child {
        color: #676767;
        height: 19px;
        line-height: 19px;
        margin-right: 18px;
      }
    }
    &.header-right {
      height: 28px;
      .right-module {
        height: 28px;
        line-height: 28px;
        span {
          display: inline-block;
          height: 28px;
          line-height: 28px;
        }
      }
    }
    &.order-header-coupon {
      span {
        &:last-child {
          min-width: 105px;
          color:#333;
        }
      }
    }
  }
  .order-detail {
    font-size: 12px;
    color: #666;
    line-height: 36px;
    border-top: 1px solid #e0e0e0;
    padding-top: 5px;
    .detail-item {
      label {
        float: left;
      }
      ul {
        float: left;
        min-width: 370px;
        li {
          color: #666;
          .free {
            display: inline-block;
            background-color: #f60;
            width: 20px;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            border-radius: 3px;
            color: #fff;
            text-align: center;
            margin-left: 3px;
          }
          .hour-num {
            line-height: 24px;
            color: #f60;
          }
        }
      }
    }
  }
  .show-order-detail-btn {
    text-align: right;
    span {
      position: relative;
      display: inline-block;
      border: 1px solid #eaeaea;
      padding: 0 10px;
      height: 24px;
      line-height: 24px;
      color: #666;
      background-color: #fff;
      border-radius: 3px;
      font-size: 12px;
      cursor: pointer;
      &::after {
        display: inline-block;
        content: "";
        width: 10px;
        height: 10px;
        background: url("../../../../assets/images/order/bg.png") no-repeat;
        background-position: -20px 0;
        margin-left: 5px;
      }
      &.span-up {
        &::after {
          background-position: -30px 0;
        }
      }
    }
  }
}
</style>
